/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { EMPTY_STRING } from '@common/tech-shared';
import { isNil } from 'lodash-es';
import { Anschrift } from './organisations-einheit.model';

export function formatAnschrift(anschrift: Anschrift): string {
  if (isNil(anschrift)) return EMPTY_STRING;
  const street: string = joinNonNil([anschrift.strasse, anschrift.hausnummer], ' ');
  const city: string = joinNonNil([anschrift.plz, anschrift.ort], ' ');
  return joinNonEmpty([street, city], ', ');
}

function joinNonNil(values: string[], separator: string): string {
  return values.filter((value) => !isNil(value)).join(separator);
}

function joinNonEmpty(values: string[], separator: string): string {
  return values.filter((value) => value.length > 0).join(separator);
}
